export const TOGGLE_GLOBAL_LOADER = "TOGGLE_GLOBAL_LOADER";

export const setGlobalLoading = (loading) => (dispatch) =>
  dispatch({
    type: TOGGLE_GLOBAL_LOADER,
    payload: loading,
  });
